import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=779dc914"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779dc914')) {
      api.createRecord('779dc914', component.options)
    } else {
      api.reload('779dc914', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=779dc914", function () {
      api.rerender('779dc914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/NotFound.vue"
export default component.exports